module.exports = __webpack_public_path__ + "static/img/openai.68fecacc.png";